import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getUsersWithoutTeam } from "api/User";


export const useUserWithoutTeam = () => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['users-without-team'],
        () => {
            return getUsersWithoutTeam();
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
